'use client';

import React from 'react';
import { useTranslation } from 'react-i18next';
import { CreateUserHeader } from '@/components/users/create-user-header';
import { CreateUserForm } from '@/components/users/create-user-form';

export default function CreateUserPage() {
  const { i18n } = useTranslation();
  const isRTL = i18n.language === 'ar';

  return (
    <div className="min-h-screen bg-background" dir={isRTL ? 'rtl' : 'ltr'}>
      {/* Header */}
      <CreateUserHeader />

      {/* Main Content */}
      <div className="max-w-6xl mx-auto p-4 sm:p-6 space-y-6 sm:space-y-8">
        <CreateUserForm />
      </div>
    </div>
  );
}
